module.exports = __webpack_public_path__ + "static/media/20.06.efe43bbc.jpg";